import React, { Fragment } from 'react';
import {
  AutocompleteInput,
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  ReferenceField,
  ReferenceInput,
  Responsive,
  ShowButton,
  TextField,
  TextInput,
} from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { List } from '../../components/List';
import { NormalActions } from '../../components/NormalActions';
import { suggestionsContainerProps } from '../../utils';

const styles = {
  filters: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: '1',
  },
};

export const ConsentBannerList = (props) => (
  <List {...props} bulkActionButtons={<CustomBulkActions/>} filters={<ConsentBannerFilter/>} actions={<CustomNormalActions/>}>
    <Responsive
      medium={
        <Datagrid>
          <TextField source="name"/>

          <ReferenceField label="Account" source="account" reference="accounts" sortable={false} allowEmpty>
            <TextField source="name"/>
          </ReferenceField>

          <ShowButton/>
          <EditButton className="edit-consent-banner-button"/>
        </Datagrid>
      }
    />
  </List>
);

// Docs: https://marmelab.com/react-admin/List.html#bulk-actions
const CustomBulkActions = (props) => (
  <Fragment>
    <BulkDeleteButton {...props} undoable={false}/>
  </Fragment>
);

const CustomNormalActions = (props) => (
  <NormalActions customClassName="create-consent-banner-button" {...props}>
    <CreateButton basePath={props.basePath}/>
  </NormalActions>
);

const ConsentBannerFilter = withStyles(styles)(({ classes, ...props }) => (
  <div className={classes.filters}>
    {props.context === 'form' ?
      <Typography variant="h5">
        Consent Banners List
      </Typography> : null}
    <Filter {...props}>
      <TextInput label="Id" source="id"/>

      <TextInput label="Name" source="name" alwaysOn/>

      <ReferenceInput label="Account" source="account" reference="accounts"
        filterToQuery={searchText => ({ name: searchText })}>
        <AutocompleteInput options={{ suggestionsContainerProps }} optionText="name"/>
      </ReferenceInput>
    </Filter>
  </div>
));
